/**
 * Status Action Builders
 * Reusable builders for status dropdown actions across entities
 * Eliminates duplication of status action definitions
 */

import type { BaseEntity } from "@/components/shared/UniversalCRMTable/types";
import type { DetailActionStrict, ActionVariant } from "../../types/detail-action";
import { ACTION_ROLES, ACTION_ICONS, ACTION_VARIANTS } from "../../types/action-properties";

/**
 * Create a status dropdown action for any entity
 * Provides sensible defaults while allowing customization
 */
export function createStatusAction<T extends BaseEntity>(
  options: {
    label?: string;
    icon?: string;
    variant?: ActionVariant;
    allowedRoles?: string[];
    primary?: boolean;
  } = {}
): DetailActionStrict<T> {
  return {
    id: "status-dropdown",
    label: options.label ?? "Status",
    icon: options.icon ?? ACTION_ICONS.CHEVRON_DOWN,
    variant: options.variant ?? ACTION_VARIANTS.OUTLINE,
    primary: options.primary ?? true,
    action: "changeStatus",
    allowedRoles: options.allowedRoles ?? [ACTION_ROLES.ADMIN],
  };
}
